/**
 * `TimeTrackingTimeSheet` has no BE status field (confirmed absent —
 * `existing-be-api-surface.md`). Cycles (T06) and All Timesheets (T09) both need a period-level
 * status label; this is the one place that derives it, so the two screens can never disagree.
 *
 * `periodStart > today` returns `null` (not rendered) — this dataset has no future cycles.
 */
export function deriveTimesheetStatus(
  periodStart: string,
  periodEnd: string,
  today: string = new Date().toISOString().slice(0, 10),
): 'Current' | 'Paid' | null {
  if (periodStart > today) return null
  return periodEnd < today ? 'Paid' : 'Current'
}
